import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 -960 960 960", width: "1em", fill: "#5f6368", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" }));
export default SvgChevronLeft;
